var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "row row--select",
      class: { "row--disabled": _vm.disabled },
    },
    [
      _vm._t("default", [
        _c("label", {
          staticClass: "leasingSearchListing__sortLabel",
          attrs: { for: _vm.id },
          domProps: { innerHTML: _vm._s(_vm.label) },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "inputWrap selectWrap" }, [
        _c(
          "select",
          {
            attrs: { name: _vm.name, id: _vm.id, disabled: _vm.disabled },
            on: { change: _vm.handleChange },
          },
          [
            _vm.defaultValue
              ? _c("option", { attrs: { value: "" } }, [
                  _vm._v(_vm._s(_vm.defaultValue)),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.items, function (item) {
              return _c(
                "option",
                {
                  key: item.value,
                  domProps: {
                    value: item.value,
                    selected: item.value == _vm.selectedValue,
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(item.name) +
                      "\n                "
                  ),
                  item["count"]
                    ? [_vm._v("(" + _vm._s(item.count) + ")")]
                    : _vm._e(),
                ],
                2
              )
            }),
          ],
          2
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }